import { HIDE_SYSTEM_ROUTE } from '../../configs';
import { GUEST_MODULE, SYSTEM_MODULE } from '../../configs/moduleNames';
import LogoutPage from './components/LogoutPage';
import LoginPage from './components/LoginPage';
import ProfilePage from './components/ProfilePage';
import NotificationPage from './components/NotificationPage';
import TestPage from './components/TestPage';

const routes = [
  // {
  //   path: '/',
  //   name: 'menu.profile',
  //   icon: 'profile',
  //   customIcon: true,
  //   loginRequired: true,
  //   component: ProfilePage,
  //   weight: 1,
  //   permission: [],
  //   children: [],
  // },
  // {
  //   path: '/test',
  //   name: 'menu.logout',
  //   permission: SYSTEM_MODULE,
  //   hideOnMenu: HIDE_SYSTEM_ROUTE,
  //   icon: 'pe-7s-power',
  //   loginRequired: false,
  //   component: TestPage,
  //   weight: 999,
  // },
  {
    path: '/notification',
    name: 'menu.logout',
    permission: SYSTEM_MODULE,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    icon: 'pe-7s-power',
    loginRequired: true,
    forAll: true,
    component: NotificationPage,
    weight: 999,
  },
  {
    path: '/',
    name: 'menu.login',
    permission: GUEST_MODULE,
    loginRequired: false,
    forAll: true,
    component: LoginPage,
    weight: 999,
  },
  {
    path: '/logout',
    name: 'menu.logout',
    permission: SYSTEM_MODULE,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    icon: 'pe-7s-power',
    loginRequired: true,
    forAll: true,
    component: LogoutPage,
    weight: 999,
  },
  // {
  //   path: '/registration',
  //   name: 'menu.registration',
  //   permission: GUEST_MODULE,
  //   hideOnMenu: HIDE_SYSTEM_ROUTE,
  //   loginRequired: false,
  //   component: RegistrationPage,
  //   weight: 999,
  // },
];

export default routes;
